import { getFirstCollapsedIdx as e, isItemCollapsed as t } from "../../controller/index.js";
import { getValidChildren as n } from "../../utils/index.js";
import { Ellipsis as r } from "../ellipsis/index.js";
import { cloneElement as i, forwardRef as a, useId as o, useMemo as s, useState as c } from "react";
import { jsx as l } from "react/jsx-runtime";
// src/design/breadcrumbs/@/components/root/index.tsx
var u = a(({ children: a, className: u, collapseThreshold: d = 4, id: f, nbItemsAfterEllipsis: p = 1, nbItemsBeforeEllipsis: m = 1, noCollapse: h = !1, onExpand: g, ..._ }, v) => {
	let y = o(), b = f ?? y, [x, S] = c(h), C = n(a), w = C.length, T = !x && w > d, E = !1;
	s(() => e(w, m, p, T), [
		w,
		m,
		p,
		T
	]);
	let D = C.reduce((e, n, a) => T && t(a, w, m, p) ? (E ||= (e.push(/* @__PURE__ */ l(r, {
		"aria-controls": b,
		"aria-expanded": !1,
		onExpand: () => {
			S(!0), g?.();
		}
	}, a)), !0), e) : (e.push(i(n, {})), e), []);
	return /* @__PURE__ */ l("nav", {
		className: "insert-your-custom-classes",
		"data-ods": "breadcrumb",
		id: b,
		ref: v,
		role: "navigation",
		..._,
		children: /* @__PURE__ */ l("ol", {
			className: u,
			children: D
		})
	});
});
u.displayName = "Root";
export { u as Root };

//# sourceMappingURL=index.js.map